import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PhpVersionService } from './../../../../core/php-version';
import { SiteApiService } from './../../../../core/site';
import { Observable, combineLatest } from 'rxjs';
import { map, shareReplay, take, tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { PhpVersionStagingChangeComponent } from '../php-version-staging-change/php-version-staging-change.component';

@Component({
  selector: 'app-manage-staging-site',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: 'manage-staging-site.component.html',
  styleUrls: ['./manage-staging-site.component.scss'],
  standalone: false,
})
export class ManageStagingSiteComponent implements OnInit {
  @Input() domain: string;
  @Input() siteId: string;
  @Input() editURL: string;

  public sftpPageLink: string;
  public phpVersionStagingState$: Observable<any>;
  public phpVersionStaging;
  public stagingWpCoreVersion$: Observable<string>;
  public stagingCoreUpToDate$: Observable<boolean>;
  private stagingWpCoreVersionLatest: string;

  constructor(
    private sanitizer: DomSanitizer,
    private phpVersionService: PhpVersionService,
    private siteApiService: SiteApiService,
    public modal: MatDialog,
  ) {
    this.phpVersionStagingState$ = this.phpVersionService
      .getPhpVersionStagingState$()
      .pipe(map((phpVersionStagingState) => phpVersionStagingState.stagingSitePhpVersion));
  }

  ngOnInit(): void {
    this.sftpPageLink = `site/${this.siteId}/advanced/sftp-key/list`;
    this.phpVersionService.loadPhpVersionStagingState();
    const stagingUpdate$ = this.siteApiService.getSiteUpdate(this.domain).pipe(shareReplay(1));
    this.stagingWpCoreVersion$ = stagingUpdate$.pipe(
      map((update: any) => update.core_version),
      tap((core: string) => (this.stagingWpCoreVersionLatest = core)),
    );
    this.stagingCoreUpToDate$ = stagingUpdate$.pipe(
      map((update: any) => update.core_version === update.latest_core_version),
    );
  }

  public siteUrl(): SafeResourceUrl {
    if (!this.domain) {
      return null;
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl('https://' + this.domain + '?display=iframe');
  }

  navigateToEditSite(): string {
    return '/redirect/wp-admin/' + this.siteId + '/?instance=staging&redirect_to=' + encodeURIComponent(this.editURL);
  }

  changeStagingPhpModal(): void {
    combineLatest([this.phpVersionStagingState$.pipe(take(1)), this.stagingWpCoreVersion$.pipe(take(1))]).subscribe(
      ([php, wpVersion]) => {
        this.phpVersionStaging = php;
        this.modal.open(PhpVersionStagingChangeComponent, {
          width: '500px',
          data: {
            php_version: this.phpVersionStaging,
            wp_version: wpVersion,
          },
        });
      },
    );
  }
}
